/**
 * Created by Victor Rojo on 21/9/17.
 */
import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {FormsModule} from '@angular/forms';
import { trigger,state,style,transition,animate,keyframes } from '@angular/animations';

@Component({
  selector: 'password-strength',
  template: `<div class="password-strength" [@fade]='fadeState'>
                <div class="help-block" i18n="@@passwordStrength">Password strength</div>
                <div class="progress">
                  <div class="progress_bar" [ngStyle]="{'width': width + '%', 'background': color}">
                  </div>
                </div>
                <div class="help-block" i18n="@@passwordRecomendation">Use uppercase, lowercase, numbers and symbols</div>
             </div>

  `,
  animations: [
    trigger('fade', [
      state('in', style({ display: 'block', opacity: 1})),
      state('out',   style({ display: 'none'})),
      transition('out => in', animate('400ms ease-in-out', keyframes([
        style({display: 'block', offset: 0}),
        style({opacity: 0.1,  offset: 0.125}),
        style({opacity: 1,  offset: 1.0}),
      ]))),
      transition('in => out', animate('400ms ease-in-out', keyframes([
        style({opacity: 0.9, offset: 0}),
        style({opacity: 0,  offset: 1.0}),
      ])))
    ])
  ],
  styles: [`
      .password-strength {

          opacity: 0;
          transition: visibility 0s, opacity 0.5s linear;
      }
      .progress{
          border-radius: 3px;
          height: 9px;
          background: #f3f2f0;
          width: 100%;
      }
      .progress_bar{
          width: 0;
          border-radius: 3px;
          height: 9px;
          padding: 0;
          margin: 0;
          transition: all 0.2s ease-in-out;
      }
      .true {
          color: green;
      }
      .false {
          color: red;
      }
  `],})
export class PasswordStrengthComponent implements OnChanges {

  @Input() password:string = '';

  public width = 0;
  private value:string;
  public colors:any = ['#D9534F','#DF6A4F','#E5804F','#EA974E','#F0AD4E','#D2AF51','#B5B154','#97B456','#7AB659','#5CB85C','#5CB85C'];
  public color = '#D9534F';
  fadeState = 'out';

  ngOnChanges(changes: SimpleChanges) {

    this.value = this.password || '';
    this.fadeState = this.value.length ? "in" : "out";

    let _force = 0;
    const _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

    const _lowerLetters = /[a-z]+/.test(this.value);
    const _upperLetters = /[A-Z]+/.test(this.value);
    const _numbers = /[0-9]+/.test(this.value);
    const _symbols = _regex.test(this.value);

    const _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];

    let _passedMatches = 0;
    for (let _flag of _flags) {
      _passedMatches += _flag === true ? 1 : 0;
    }

    _force += 10 * this.value.length + ((this.value.length >= 10) ? 1 : 0);
    _force += _passedMatches * 20;

    // penality (short password)
    if (this.value.length < 2) {
      _force = Math.min(_force, 10);
    } else if ( this.value.length < 3 ){
      _force = Math.min(_force, 20);
    } else if ( this.value.length < 5 ) {
      _force = Math.min(_force, 30);
    }

    // penality (poor variety of characters)
    _force = (_passedMatches === 1) ? Math.min(_force, this.value.length * 3) : _force;
    _force = (_passedMatches === 2) ? Math.min(_force, this.value.length * 4) : _force;
    _force = (_passedMatches === 3) ? Math.min(_force, this.value.length * 5) : _force;
    if (_force < 101) {
      if(_force < 0) {
        this.width = 0;
      } else {
        this.width = _force;
      }
    } else {
      this.width = 100;
    }
    this.updateBar();
  }

  updateBar() {
    var i = Math.round(this.width/10);
    this.color = this.colors[i];
  }
}
